import Vue from 'vue'
import VueRouter from 'vue-router'
import { isPC }from '../utils/ispc'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    redirect: { path:isPC() ? "/home" : "/index"},
  },
  {
    path: '/home',
    name: 'Home',
    component: ()=>import('../views/home.vue'),
    beforeEnter: (to, from, next) => {
      if(isPC()){
        next()
      }else{
        next({
          path:'/index',
          //  query: to.query
        })
      }
    }
  },
  {
    path: '/index',
    name: 'Index',
    component: ()=>import('../views/index.vue'),
    beforeEnter: (to, from, next) => {
      if(isPC()){
        next({
          path:'/home',
          //  query: to.query
        })
      }else{
        next()
      }
    }
  }

]

const router = new VueRouter({
  mode: 'hash',
  routes
})
export default router
